import { ReactNode } from 'react';
import { ThemeProvider as CustomThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { theme as defaultTheme } from './theme';
interface AppThemeProps {
  children: ReactNode;
}

export const ThemeProvider = (props: AppThemeProps) => {
  const { children } = props;

  return (
    <CustomThemeProvider theme={defaultTheme} disableTransitionOnChange>
      <CssBaseline enableColorScheme />
      {children}
    </CustomThemeProvider>
  );
};
